<template>
	<div v-title title="商品分类" class="overwrite_productOrderList" style="
      height: 100vh;
      overflow-y: auto;
      overflow-x: hidden;
      background-color: #fff;
    ">
		<div>
			<van-sidebar v-model="activeKey" @change="changeCategory">
				<van-sidebar-item :title="item.name" v-for="item in dataList" :key="item.name">
				</van-sidebar-item>
			</van-sidebar>
		</div>

		<div style="width: calc(100vw - 80px)">
			<div class="level-title">
				{{ categoryData.name }}
			</div>
			<van-grid>
				<van-grid-item class="goods-box" v-for="item in categoryData.children" :key="item.code" icon="photo-o" text="文字"
					@click="goProductList(item.code)">
					<van-image class="img" :src="item.icon" />
					<div class="text">
						{{ item.name }}
					</div>
				</van-grid-item>
			</van-grid>
		</div>

		<TabBar active="sort"> </TabBar>

		<div ref="maidian" td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/sort"></div>
	</div>
</template>

<script>
import { baseUrl } from 'common/env'
import { Search } from 'vant'
import { areaList } from '@vant/area-data'
import { postnotoken } from 'api/postnotoken'
import { get } from 'api/get'
import TabBar from '@/components/tabBar/index'

export default {
	name: 'home',
	components: {
		TabBar,
	},
	data() {
		return {
			activeKey: 0,
			dataList: [
				{
					code: '',
					name: '',
					icon: '',
					children: [
						{
							code: '',
							name: '',
							icon: '',
						},
					],
				},
			],
			categoryData: {},
		}
	},
	created() {
		this.dataList = []
		this.loadCategory()

		let self = this
		this.$nextTick(() => {
			self.$refs['maidian'].click()
		})
	},
	methods: {
		loadCategory() {
			let self = this
			get('product/categoryTreeList').then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					self.dataList = JSON.parse(JSON.stringify(res.data))
					this.changeCategory(0)
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754a',
					})
				}
			})
		},
		changeCategory(index) {
			console.log('index : ' + index)
			this.categoryData = this.dataList[index]
		},
		submit() { },
		changeTab() {
			if (this.active === 0) {
				if (this.timeOrder === '' || this.timeOrder === 0) {
					this.timeOrder = 1
				} else {
					this.timeOrder = 0
				}
			} else if (this.active === 1) {
				if (this.saleOrder === '' || this.saleOrder === 0) {
					this.saleOrder = 1
				} else {
					this.saleOrder = 0
				}
			} else if (this.active === 2) {
				if (this.priceOrder === '' || this.priceOrder === 0) {
					this.priceOrder = 1
				} else {
					this.priceOrder = 0
				}
			} else if (this.active === 3) {
				if (this.gridType === '' || this.gridType === 0) {
					this.gridType = 1
					this.colnum = 1
					this.directionType = 'horizontal'
				} else {
					this.gridType = 0
					this.colnum = 2
					this.directionType = 'vertical'
				}
			}
		},
		goProductList(categoryCode) {
			console.log('categoryCode: ' + categoryCode)
			this.$router.push({
				path: '/productlsit',
				query: { categoryCode: categoryCode },
			})
		},
	},
}
</script>

<style lang="less" scoped>
.overwrite_productOrderList {
	display: flex;
	flex-direction: row;

	/deep/.van-sidebar-item--select::before {
		left: 14px;
		top: unset;
		bottom: 4px;
		width: 14px;
		height: 3px;
		background: #00754a;
		border-radius: 2px;
		transform: translateY(0);
		content: '';
	}

	.van-grid {
		background: #fff;
	}
}

/deep/.van-sidebar {
	min-width: 100px;
}

/deep/.van-sidebar-item {
	margin-bottom: 10px;
	height: unset;
	line-height: unset;
	background-color: #fff;
	color: #333;
	font-size: 13px;
	font-weight: 400;
	padding: unset;
}

/deep/.van-sidebar-item__text {
	padding: 10px 14px;
}

/deep/.van-sidebar-item--select {
	color: #00754a;
	font-weight: 500;
}

/deep/.van-grid-item__content--surround::after {
	border: unset;
}

/deep/ .van-grid-item__content::after {
	border: unset;
}

/deep/[class*=van-hairline]::after {
	border: none;
}

.level-title {
	padding: 11px 0 10px;
	height: 14px;
	font-size: 12px;
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	color: #999999;
	line-height: 14px;
	width: 262px;
	border-bottom: 1px solid #eeeeee;
}

.goods-box {
	width: 70px;
	margin-right: 25px;
	margin-top: 17px;

	/deep/.van-grid-item__content {
		padding: 0;

		.img {
			width: 70px;
			height: 70px;
		}

		.text {
			margin: 6px 0 3px;
			height: 14px;
			font-size: 11px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #333333;
			line-height: 14px;
		}
	}
}

.goods-box:nth-child(3n) {
	margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/product/sort.vue